function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.376 13.218l.91 3.578-3.575-.911h-.13c-1.203.683-2.633 1.008-4.161.91-3.478-.26-6.338-3.057-6.696-6.537-.455-4.619 3.413-8.49 8.029-8.034 3.478.358 6.273 3.188 6.533 6.7a7.17 7.17 0 01-.91 4.164v.13z",
  strokeLinejoin: "round",
  strokeWidth: 1.25
});

var SvgThreadsComment = function SvgThreadsComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Comment",
    viewBox: "0 0 18 18",
    stroke: "#424242",
    fill: "transparent"
  }, props), _ref);
};

export default SvgThreadsComment;